import type { BillingUsageCallDto } from '@shared/services/apiService';
import { formatBillingUnits } from './formatBillingUnits';
/** Quote every field; neutralize spreadsheet formula prefixes, including leading control/space. */
export const csvCell = (value: string): string => {
  const safe = /^[\s\u0000-\u001f]*[=+@-]/.test(value) ? `'${value}` : value;
  return `"${safe.replace(/"/g, '""')}"`;
};
export const billingCallsCsv = (rows: BillingUsageCallDto[], scale: number): string => {
  const credits = (n: string) => formatBillingUnits(n, scale).replace(/,/g, '');
  return (
    '\uFEFF' +
    [
      [
        'Call ID',
        'First posting (UTC)',
        'Campaign',
        'Agent',
        'Plan credits',
        'Top-up credits',
        'Total credits',
      ],
      ...rows.map((r) => [
        r.callId,
        r.date,
        r.campaignName,
        r.agentName,
        credits(r.planUnits),
        credits(r.topUpUnits),
        credits(r.totalUnits),
      ]),
    ]
      .map((r) => r.map(csvCell).join(','))
      .join('\r\n')
  );
};
